
const initialState = {
    domainStatusResponse: null,
    domainDetails: null,
    startScanResponse: null,
    assetInventorySubdomainList:null,
    assetInventoryIpAddressList:null,
    assetInventoryEmailList:null,
    subDomainIncludeResponse: null,
    subDomainExcludeResponse: null,
    ipAddressIncludeResponse: null,
    ipAddressExcludeResponse: null,
    emailIncludeResponse: null,
    emailExcludeResponse: null,
    deleteDomainResponse: null,
    updateDomainResponse: null,
    scanHistoryList: null,
    serverList: null
}

export default function domainReducer(state=initialState, action) {
    switch(action.type) {
        case 'DOMAIN_STATS_SUCCESS' :
            return {
                ...state,
                domainStatusResponse: action.payload
            }
        case 'DOMAIN_DETAILS_SUCCESS' :
            return {
                ...state,
                domainDetails: action.payload
            }
        case 'RESET_DOMAIN_DETAILS' :
            return {
                ...state,
                domainDetails: null
            }
        case 'START_SCAN_SUCCESS' : 
            return {
                ...state,
                startScanResponse: action.payload
            }
        case 'RESET_START_SCAN_RESPONSE' :
            return {
                ...state,
                startScanResponse: null
            }
        case 'ASSET_INVENTORY_SUBDOMAIN_LIST' :
            return {
                ...state,
                assetInventorySubdomainList: action.payload
            }
        case 'ASSET_INVENTORY_IP_ADDRESS_LIST' :
            return {
                ...state,
                assetInventoryIpAddressList: action.payload
            }
        case 'ASSET_INVENTORY_EMAILS_LIST' :
            return {
                ...state,
                assetInventoryEmailList: action.payload
            }
        case 'SUBDOMAIN_INCLUDE_SUCCESS' : 
            return {
                ...state,
                subDomainIncludeResponse: action.payload
            }
        case 'SUBDOMAIN_EXCLUDE_SUCCESS' : 
            return {
                ...state,
                subDomainExcludeResponse: action.payload
            }
        case 'IP_ADDRESS_INCLUDE_SUCCESS' : 
            return {
                ...state,
                ipAddressIncludeResponse: action.payload
            }
        case 'IP_ADDRESS_EXCLUDE_SUCCESS' : 
            return {
                ...state,
                ipAddressExcludeResponse: action.payload
            }
        case 'EMAIL_INCLUDE_SUCCESS' : 
            return {
                ...state,
                emailIncludeResponse: action.payload
            }
        case 'EMAIL_EXCLUDE_SUCCESS' : 
            return {
                ...state,
                emailExcludeResponse: action.payload
            }
        case 'RESET_INCLUDE_EXCLUDE_RESPONSE' : 
            return {
                ...state,
                subDomainIncludeResponse: null,
                subDomainExcludeResponse: null,
                ipAddressIncludeResponse: null,
                ipAddressExcludeResponse: null,
                emailIncludeResponse: null,
                emailExcludeResponse: null
            }
        case 'DELETE_DOMAIN_SUCCESS' :
            return {
                ...state,
                deleteDomainResponse: action.payload
            }
        case 'RESET_DELETE_DOMAIN_RESPONSE' :
            return {
                ...state,
                deleteDomainResponse: null
            }
        case 'UPDATE_DOMAIN_SUCCESS' : {
            return {
                ...state,
                updateDomainResponse: action.payload
            }
        }
        case 'RESET_UPDATE_DOMAIN_RESPONSE': 
            return {
                ...state,
                updateDomainResponse: null
            }
        case 'SCAN_HISTORY_SUCCESS':
            return {
                ...state,
                scanHistoryList: action.payload
            }
        case 'RESET_SCAN_HISTORY_LIST':
            return {
                ...state,
                scanHistoryList: null
            }
        case 'SERVER_LIST_SUCCESS':
            return {
                ...state,
                serverList: action.payload
            }
        default:
            return state;
    }
}